import { routes as appInspectorRoutes } from '@localstack/appinspector-ui/routes';

import { RB_ROUTES } from './resources';
import { PATH_PREFIX_INSTANCE, PATH_PREFIX_RESOURCES, PATH_PREFIX_APPINSPECTOR } from './routes';

const buildRouteConstants = <Routes extends Record<string, string>, Prefix extends string>(
  routes: Routes,
  prefix: Prefix,
) => {
  return Object.fromEntries(Object.entries(routes).map(([key, path]) => [key, `${prefix}/${path}`])) as {
    [K in keyof Routes]: `${Prefix}/${Routes[K]}`;
  };
};

export const INSTANCE_ROUTES = {
  INSTANCE_COMMON: `${PATH_PREFIX_INSTANCE}/*`,
  STACK_OVERVIEW: `${PATH_PREFIX_INSTANCE}/overview`,
  STATUS: `${PATH_PREFIX_INSTANCE}/status`,
  INSTANCE_STATE: `${PATH_PREFIX_INSTANCE}/state`,
  INSTANCE_LOGS: `${PATH_PREFIX_INSTANCE}/logs`,
  INSTANCE_SNOWFLAKE: `${PATH_PREFIX_INSTANCE}/snowflake`,

  RESOURCES_COMMON: `${PATH_PREFIX_RESOURCES}/*`,
  RESOURCES_OVERVIEW: `${PATH_PREFIX_RESOURCES}`,

  IAM_POLICY_STREAM: `${PATH_PREFIX_INSTANCE}/policy-stream`,
  CHAOS_ENGINEERING: `${PATH_PREFIX_INSTANCE}/chaos-engineering`,

  ...buildRouteConstants(appInspectorRoutes, PATH_PREFIX_APPINSPECTOR),

  EXTENSIONS_MANAGE: `${PATH_PREFIX_INSTANCE}/extensions/manage`,
  EXTENSIONS_DETAILS: `${PATH_PREFIX_INSTANCE}/extensions/details/:plugin_name`,

  ...RB_ROUTES,
} as const;
